import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EnumsDataService {
  private enumsDataSubject = new BehaviorSubject<any>(null);
  enumsData$ = this.enumsDataSubject.asObservable();

  setEnumsData(data: any): void {
    this.enumsDataSubject.next(data);
  }

  getEnumsData() {
    return this.enumsDataSubject.getValue();
  }

  getEnumByKey(key: string): any {
    const enumsData = this.getEnumsData();
    return enumsData ? enumsData[key] : null;
  }
}
